{
  "title": "Emplacements",
  "subtitle": "Vos entrepôts et magasins. Dans chacun, vous pouvez ajouter des zones, étagères ou casiers.",
  "newLocation": "Nouvel emplacement",
  "empty": {
    "title": "Aucun emplacement pour l'instant",
    "text": "Créez votre premier entrepôt, magasin ou dépôt. Le stock est toujours suivi par emplacement."
  },
  "products_one": "{{formatted}} produit",
  "products_many": "{{formatted}} produits",
  "products_other": "{{formatted}} produits",
  "status": {
    "active": "Actif",
    "deactivated": "Désactivé",
    "empty": "Vide"
  },
  "fields": {
    "name": "Nom",
    "type": "Type",
    "code": "Code",
    "address": "Adresse",
    "city": "Ville",
    "phone": "Téléphone",
    "responsible": "Responsable"
  },
  "list": {
    "title": "Tous les emplacements · {{count}}",
    "systemLine": "Système · créé automatiquement, lecture seule",
    "subCount_one": "{{count}} sous-emplacement",
    "subCount_many": "{{count}} sous-emplacements",
    "subCount_other": "{{count}} sous-emplacements",
    "deactivatedOn": "Désactivé le {{date}}",
    "footnote": "Un emplacement avec du stock ne peut pas être fermé. Un emplacement avec un historique n'est jamais supprimé, seulement désactivé.",
    "back": "Tous les emplacements"
  },
  "detail": {
    "system": "Système",
    "systemHint": "La marchandise entre deux sites pendant un transfert. Créé par le système, il ne peut pas être modifié.",
    "inside": "Dans",
    "responsible": "Responsable : {{name}}",
    "productsHere": "Produits ici",
    "stockValue": "Valeur du stock",
    "attention": "À surveiller",
    "attentionDetail": "{{low}} bas · {{over}} en surstock",
    "subLocations": "Sous-emplacements",
    "addSub": "Ajouter une zone, étagère ou casier",
    "noSub": "Aucun sous-emplacement. Ajoutez des zones, étagères ou casiers pour savoir exactement où se trouvent les choses.",
    "products": "Produits",
    "value": "Valeur (TND)",
    "status": "Statut",
    "subHint": "Déplacer du stock entre deux sous-emplacements d'un même site se fait en une étape, sans « En transit ».",
    "whoCanWork": "Qui peut travailler ici",
    "nobody": "Personne n'est encore limité à ce site. Les administrateurs et les personnes ayant accès à tous les emplacements peuvent y travailler.",
    "isResponsible": "responsable",
    "allLocations": "tous les emplacements",
    "manageAccess": "Gérer les accès",
    "close": "Fermer cet emplacement",
    "closeHint": "Un emplacement avec un historique n'est jamais supprimé, seulement désactivé. Déplacez ou sortez d'abord tout son stock pour qu'il soit à zéro. Ses sous-emplacements ferment avec lui.",
    "closeSubHint": "Déplacez d'abord tout son stock vers un autre endroit pour qu'il soit à zéro.",
    "deactivate": "Désactiver",
    "deactivateBlocked": "Désactiver · le stock n'est pas à zéro",
    "deactivateTitle": "Désactiver {{name}} ?",
    "deactivateText": "Personne ne pourra plus l'utiliser dans les opérations. Son historique reste, et vous pourrez le réactiver plus tard.",
    "deactivateWithSubs_one": "Son sous-emplacement actif est désactivé aussi. L'historique reste, et vous pourrez les réactiver plus tard.",
    "deactivateWithSubs_many": "Ses {{count}} sous-emplacements actifs sont désactivés aussi. L'historique reste, et vous pourrez les réactiver plus tard.",
    "deactivateWithSubs_other": "Ses {{count}} sous-emplacements actifs sont désactivés aussi. L'historique reste, et vous pourrez les réactiver plus tard.",
    "deactivated": "{{name}} désactivé",
    "reopen": "Emplacement désactivé",
    "reopenHint": "Réactivez-le pour l'utiliser à nouveau dans les opérations.",
    "reactivate": "Réactiver",
    "reactivated": "{{name}} réactivé",
    "delete": "Supprimer",
    "deleteTitle": "Supprimer {{name}} ?",
    "deleteText": "Cet emplacement n'a jamais servi. Il est supprimé définitivement ; le journal d'activité garde une trace de la suppression.",
    "deleted": "{{name}} supprimé",
    "viewStock": "Voir son stock"
  },
  "form": {
    "newSite": "Nouvel emplacement",
    "editSite": "Modifier l'emplacement",
    "newSub": "Nouvelle zone, étagère ou casier dans {{site}}",
    "editSub": "Modifier le sous-emplacement",
    "siteHint": "Un entrepôt, un magasin ou un dépôt : un lieu qui a son propre stock.",
    "subHint": "Un endroit précis dans le site. Le stock se déplace dans un site en une étape.",
    "codeHint": "Court, pour les listes et les exports : MAIN, SOU-A.",
    "noResponsible": "Personne",
    "saved": "Emplacement enregistré",
    "created": "{{name}} créé"
  },
  "access": {
    "title": "Qui peut travailler à {{name}}",
    "hint": "Les personnes limitées à leurs propres emplacements. Cochez celles qui travaillent dans ce site.",
    "nobody": "Personne n'est limité à des emplacements précis. Choisissez d'abord « Emplacements attribués uniquement » pour une personne dans Utilisateurs et rôles.",
    "everywhere": "Peuvent déjà travailler partout : {{names}}",
    "saved": "Accès enregistrés"
  }
}
